module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "statementbtn"
  }, [_c('Button', {
    on: {
      "click": function($event) {
        return _vm.clickHandler('statement')
      }
    }
  }, [_vm._v("Подать заявление")]), _c('Button', {
    attrs: {
      "bordered": true
    },
    on: {
      "click": function($event) {
        return _vm.clickHandler('close')
      }
    }
  }, [_vm._v("Не сейчас")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3fc30b32","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/views/certificate/components/statementbtn/StatementBtn.vue
// module id = c362477ba6bcfb4ba6f3
// module chunks = 9